<template>
  <div class="submit-registration-container">
    <!-- 报考信息 -->
    <div class="section application-info">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">报考信息</span>
      </div>
      <div class="section-content">
        <div class="info-row">
          <div class="info-item">
            <span class="label">助学点:</span>
            <span class="value">{{ helpInfo.code+'-'+helpInfo.name }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">报考专业:</span>
            <span class="value">{{ specialtyName }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 报名信息 -->
    <div class="section registration-info">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">报名信息</span>
      </div>
      <div class="section-content d-flex d-flex-top d-flex-wrap">
        <div class="info-item">
          <span class="label">姓名:</span>
          <span class="value">{{ formData.name }}</span>
        </div>
        <div class="info-item">
          <span class="label">性别:</span>
          <span class="value">{{ getGenderLabel(formData.gender) }}</span>
        </div>
        <div class="info-item">
          <span class="label">民族:</span>
          <span class="value">{{ getNationLabel(formData.nation) }}</span>
        </div>
        <div class="info-item">
          <span class="label">证件类型:</span>
          <span class="value">{{ getDictLabel(formData.idType, 'id_type') }}</span>
        </div>
        <div class="info-item">
          <span class="label">证件号码:</span>
          <span class="value">{{ formData.idCardNumber }}</span>
        </div>
        <div class="info-item">
          <span class="label">出生日期:</span>
          <span class="value">{{ formData.birthday }}</span>
        </div>
        <div class="info-item">
          <span class="label">原最高学历:</span>
          <span class="value">{{ getDictLabel(formData.oldEducation, 'eduleveles') }}</span>
        </div>
        <div class="info-item">
          <span class="label">手机号:</span>
          <span class="value">{{ formData.phone }}</span>
        </div>
        <div class="info-item">
          <span class="label">常住地:</span>
          <span class="value">{{ getFullAddressName() }}</span>
        </div>
        <div class="info-item">
          <span class="label">通讯地址:</span>
          <span class="value">{{ formData.contactAddress }}</span>
        </div>

        <div class="info-item">
          <span class="label">家庭联系人关系:</span>
          <span class="value">{{ formData.contactRelationship?formData.contactRelationship:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactRelationship : '') }}</span>
        </div>
        <div class="info-item">
          <span class="label">家庭联系人姓名:</span>
          <span class="value">{{ formData.contactName?formData.contactName:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactName : '') }}</span>
        </div>

        
        
        
        <div class="info-item">
          <span class="label">家庭联系人手机号:</span>
          <span class="value">{{ formData.contactPhone?formData.contactPhone:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactPhone : '') }}</span>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="submit-button-container">
      <el-button class="prev-btn" @click="handlePrev">上一步</el-button>
      <el-button type="primary" class="submit-btn" @click="handleSubmit">提交报名</el-button>
    </div>
  </div>
</template>

<script>
import addressData from '@/data/address.js'

export default {
  name: 'SubmitRegistration',
  props: {
    // 是否需要从接口查询学生信息（用于 mineBm 场景的数据回显）
    needQueryStudentInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      helpInfo: {},
      specialtyName: '',
      formData: {},
      dictData: {
        id_type: [],
        eduleveles: [],
        nation: [],
        gender: []
      },
      addressOptions: []
    }
  },
  created() {
    this.loadAddressData()
    this.loadFormData()
    this.getDictData()
  },
  methods: {
    // 加载地址数据
    loadAddressData() {
      this.addressOptions = addressData
    },
    // 获取字典数据
    getDictData() {
      this.$http.post('/student/common/getDictItemByTypes', ['id_type', 'eduleveles', 'nation', 'gender']).then(res => {
        if (res.id_type) {
          this.dictData.id_type = res.id_type
        }
        if (res.eduleveles) {
          this.dictData.eduleveles = res.eduleveles
        }
        if (res.nation) {
          this.dictData.nation = res.nation
        }
        if (res.gender) {
          this.dictData.gender = res.gender
        }
      }).catch(err => {
        console.error('获取字典数据失败:', err)
      })
    },
    // 根据字典类型和值获取标签
    getDictLabel(value, dictType) {
      if (!value) return ''
      const dictList = this.dictData[dictType] || []
      const item = dictList.find(item => item.value === value || item.label === value)
      return item ? item.label : value
    },
    // 获取民族标签
    getNationLabel(value) {
      if (!value) return ''
      const item = this.dictData.nation.find(item => item.value === value)
      return item ? item.label : value
    },
    // 获取性别标签
    getGenderLabel(value) {
      if (!value) return ''
      const item = this.dictData.gender.find(item => item.value === value)
      return item ? item.label : value
    },
    // 根据地址代码获取地址名称
    getAddressName(code) {
      if (!code) return ''
      // 统一转换为数字进行比较（地址数据中的code是数字类型）
      const codeNum = typeof code === 'string' ? parseInt(code) : code
      if (isNaN(codeNum)) return code
      
      // 遍历省份
      for (const province of this.addressOptions) {
        if (province.code === codeNum) {
          return province.name
        }
        // 遍历城市
        if (province.children) {
          for (const city of province.children) {
            if (city.code === codeNum) {
              return city.name
            }
            // 遍历区县
            if (city.children) {
              for (const district of city.children) {
                if (district.code === codeNum) {
                  return district.name
                }
              }
            }
          }
        }
      }
      return code
    },
    // 获取完整地址名称
    getFullAddressName() {
      if (!this.formData.registerProvince || !this.formData.registerCity || !this.formData.registerRegion) {
        return ''
      }
      const provinceName = this.getAddressName(this.formData.registerProvince)
      const cityName = this.getAddressName(this.formData.registerCity)
      const regionName = this.getAddressName(this.formData.registerRegion)
      return `${provinceName}-${cityName}-${regionName}`
    },
    // 加载表单数据
    loadFormData() {
      // 加载报考信息
      this.helpInfo = JSON.parse(localStorage.getItem('helpInfo')) || {}
      const specId = localStorage.getItem('specId')
      
      // 获取专业名称
      if (specId) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getSpecialtyList/'+specId+'?target_id=21849fb0f0705f').then(res => {
          this.specialtyName = res.code+'-'+res.name
        })
      }
      
      // 如果需要从接口查询学生信息（mineBm 场景）
      if (this.needQueryStudentInfo) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
          if (res) {
            this.formData = res
          }
        })
      } else {
        this.loadFromLocalStorage()
      }
    },
    loadFromLocalStorage() {
      const registerFormData = localStorage.getItem('registerFormData')
      if (registerFormData) {
        this.formData = JSON.parse(registerFormData)
      }
    },
    // 提交报名
    handleSubmit() {
      this.$confirm('确认提交报名信息吗？请仔细核对信息。', '确认提交', {
        confirmButtonText: '确认提交',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        // 从缓存获取助学点和专业信息
        const helpInfo = JSON.parse(localStorage.getItem('helpInfo')) || {}
        const specId = localStorage.getItem('specId')
        
        // 将地址代码转换为名称
        const registerProvinceName = this.getAddressName(this.formData.registerProvince)
        const registerCityName = this.getAddressName(this.formData.registerCity)
        const registerRegionName = this.getAddressName(this.formData.registerRegion)
        
        // 组装提交数据，从缓存获取 helpId 和 specialtyId，并将地址代码转换为名称
        const submitData = {
          ...this.formData,
          registerProvince: registerProvinceName,
          registerCity: registerCityName,
          registerRegion: registerRegionName,
          helpId: helpInfo.id || helpInfo.helpId || this.formData.helpId || '',
          specialtyId: specId || this.formData.specialtyId || '',
          contactName: this.formData.contactName?this.formData.contactName:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactName : ''),
          contactPhone: this.formData.contactPhone?this.formData.contactPhone:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactPhone : '')  ,
          contactRelationship: this.formData.contactRelationship?this.formData.contactRelationship:(this.formData.contactList && this.formData.contactList.length > 0 ? this.formData.contactList[0].contactRelationship : ''),
          schoolId: helpInfo.school?.id || this.formData.schoolId || '',
        }
        
        this.$http.post(this.MOCK_PREFIX + '/student/pc/submit', submitData).then(res => {
          this.$message.success('操作成功')
          this.$emit('next-step',res.registerInfoId)
        })
      })
    },
    handlePrev() {
      this.$emit('prev-step')
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-registration-container {
  width: 100%;
  padding: 30px 0;
}

.section {
  margin-bottom: 20px;

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .title-bar {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #1890ff;
      margin-right: 10px;
      border-radius: 2px;
    }

    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  .section-content {
    background: #fff;
    .info-item {
      width: calc(100% / 3);
      font-size: 14px;
      box-sizing: border-box;
      padding: 10px 0;
      .label {
        color: #767676;
        margin-right: 10px;
        font-weight: 400;
      }

      .value {
        color: #303133;
        font-weight: 400;
        flex: 1;
        word-break: break-all;
        line-height: 1.5;
      }
    }
  }
}

.application-info {
  .section-content {
    padding: 20px 0;
  }

  .info-row {
    display: flex;
    gap: 80px;
    padding: 0 20px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    
  }
}

.registration-info {
  .section-content {
    padding: 20px 0;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 50px;
    padding: 0 20px;

    .info-column {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .info-item {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        line-height: 1.6;

        .label {
          color: #767676;
          margin-right: 10px;
          flex-shrink: 0;
          font-weight: 400;
        }

        .value {
          color: #303133;
          flex: 1;
          word-break: break-all;
          font-weight: 400;
        }
      }
    }
  }
}

.submit-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0 20px;
  .prev-btn {
    width: 160px;
    height: 40px;
    background: #fff;
    border: 1px solid #1890ff;
    color: #1890ff;
    border-radius: 8px;
    font-size: 16px;

    &:hover {
      background: #f0f7ff;
    }
  }

  .submit-btn {
    width: 160px;
    height: 40px;
    background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
    border-radius: 10px 10px 10px 10px;
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;


    &:active {
      background: #096dd9;
    }
  }
}


</style>
